export const INVALID_EMAIL_CHARS = '\u200B';
export const IS_EMAIL_DEFAULT_OPTIONS = { blacklisted_chars: INVALID_EMAIL_CHARS };
